import React, { useState } from "react";
import { useVentasConfirmadas } from "../../../hooks/useVentasConfirmadas.js";

// Componentes
import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import VentaCard from "../tarjetaVentas/ventaCard.js";
import BotonAccion from "../../../componentsUI/formularios/button/BotonAction.js";

import "./facturasLista.css";

export default function ListaFacturasConfirmadas() {
  const { ventas, loading, cargarVentas } = useVentasConfirmadas();
  const [facturaAbierta, setFacturaAbierta] = useState(null);

  if (loading) return <div>Cargando...</div>;

  return (
    <div>
      <TituloModulo titulo="Facturas Confirmadas" />
      <BotonAccion onClick={() => cargarVentas({ fuerza: true })}>
        Cargar
      </BotonAccion>
      <div className="contenedor-lista">
        {ventas.map((factura) => (
          <VentaCard
            key={factura.id_factura || factura.numero_factura} // siempre único
            factura={factura} // pedidos ya normalizados en provider
            abierta={facturaAbierta === factura.numero_factura}
            onToggle={() =>
              setFacturaAbierta(
                facturaAbierta === factura.numero_factura
                  ? null
                  : factura.numero_factura,
              )
            }
          />
        ))}
      </div>
    </div>
  );
}
